import React from "react";
import Portal from "./Portal";
import { Overlay, Background, Container } from "./styles";

const Modal = ({
  id = "modalContainer",
  children,
  onClose,
  isOpen,
  selector = undefined,
  className = "modal",
  topOffset = "10%",
  darker = false,
}) => {
  return (
    <>
      {isOpen && (
        <Portal selector={selector}>
          <Overlay id={id} className={className} isOpen={isOpen}>
            <Background darker={darker} onClick={onClose} />
            <Container topOffset={topOffset}>{children}</Container>
          </Overlay>
        </Portal>
      )}
    </>
  );
};

export default Modal;
